import React, { useState, useEffect } from "react";
import  BreadcrumbPage  from "../Common/CommonSections/Breadcrum";
import BannerComponent from "./AbouMayoBanner";
import InfrastructureComponent from "./Infrastructure";
import GalleryComponent from './Gallery';
import { getAboutMayoGallery } from "../../services/routes.services";

const AbouMayoRoute = () =>{
    const [bannerImg, setBannerImg] = useState([]);
    const [media, setMedia]= useState([]);
    const [imageGallery, setImageGallery]= useState([])
    useEffect(()=>{
        getAboutMayoGallery().then((res) => {
            setBannerImg(res.data.mayo)
            setMedia(res.data);
            setImageGallery(res.data.gallery)
        })
        .catch(error => {
            console.log(error);
        })
    }, [])
//console.log(imageGallery)
    return(
        <div>
            <BreadcrumbPage home="Home" listOne="About Mayo"/>
            <BannerComponent SliderImage={bannerImg}  />
             <InfrastructureComponent />
           <GalleryComponent galleryImg={media} gallery={imageGallery}/>
        </div>
    )
}

export default AbouMayoRoute;